import React from "react";
import { TrendingUp, Users, ShieldCheck, MessageCircle, Globe, Coins, Bitcoin } from "lucide-react";

const ApproachSection = () => {
  const features = [
    { icon: TrendingUp, label: "Long-term, fundamentals-first" },
    { icon: ShieldCheck, label: "Shariah screening overlays" },
    { icon: Globe, label: "US, PSX, Commodities & Crypto" },
    { icon: MessageCircle, label: "Community discussion on Discord" },
  ];

  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="py-20 md:py-32 bg-ics-navy-mid"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <div className="section-divider" />
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-ics-white mb-8">
              What is Investment Circle Shariah?
            </h2>
            <div className="space-y-6 text-ics-gray leading-relaxed">
              <p>
                A community of <span className="text-ics-white font-medium">hundreds of members</span>, 
                united by a passion for ethical investing. We share research and analysis on investment 
                opportunities across multiple markets.
              </p>
              <p>
                Our focus is on <span className="text-ics-white font-medium">Shariah-compliant, long-term investing</span> in 
                US equities, Pakistan Stock Exchange (PSX), Commodities, and Crypto. We apply Islamic finance principles 
                to filter and evaluate opportunities.
              </p>
              <p className="text-sm border-l-2 border-ics-orange pl-4 italic">
                We are not a brokerage, not a legal entity, and not financial advisors. 
                We share research and analysis only.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {features.map((feature, index) => (
              <div
                key={index}
                data-testid={`approach-feature-${index}`}
                className="glass-card feature-card rounded-xl p-6 hover-lift cursor-default"
              >
                <div className="feature-icon mb-4">
                  <feature.icon className="w-6 h-6" />
                </div>
                <span className="text-sm font-medium text-ics-white">
                  {feature.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;
